import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=25b0beac&"
import script from "./CustomForm.ts?vue&type=script&lang=ts&"
export * from "./CustomForm.ts?vue&type=script&lang=ts&"
import style0 from "./CustomForm.less?vue&type=style&index=0&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports